import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { sanitizeHtml } from '../utils/sanitize';

const PAGE_META: Record<string, { icon: string; fallbackTitle: string }> = {
  privacy: { icon: '🔒', fallbackTitle: 'سياسة الخصوصية' },
  terms: { icon: '📜', fallbackTitle: 'الشروط والأحكام' },
  about: { icon: '🐑', fallbackTitle: 'عن موقع الجلب' },
};

export default function StaticPage({ slug }: { slug: string }) {
  const navigate = useNavigate();
  const [page, setPage] = useState<{ title_ar: string; content_ar: string } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const meta = PAGE_META[slug] || { icon: '📄', fallbackTitle: 'صفحة' };

  useEffect(() => {
    setLoading(true);
    setError(false);
    api.get('/pages/' + slug)
      .then((res) => setPage(res.data.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-primary-500 border-t-transparent" />
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="min-h-screen bg-gray-50 py-8 px-4" dir="rtl">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 text-center">
            <span className="text-3xl block mb-4">⚠️</span>
            <h2 className="text-xl font-bold text-gray-900 mb-2">الصفحة غير متوفرة</h2>
            <p className="text-gray-500 mb-6">لم نتمكن من تحميل هذه الصفحة. يرجى المحاولة لاحقاً.</p>
            <button onClick={() => navigate('/')} className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-xl font-semibold transition">
              العودة للرئيسية
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4" dir="rtl">
      <div className="max-w-2xl mx-auto space-y-6">
        <div className="text-center">
          <div className="w-16 h-16 bg-primary-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">{meta.icon}</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-900">{page.title_ar}</h1>
        </div>
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 sm:p-8">
          <div className="text-gray-700 leading-relaxed text-sm sm:text-base" style={{ direction: 'rtl' }}
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(page.content_ar) }} />
        </div>
        <div className="text-center pb-4">
          <button onClick={() => navigate(-1)} className="text-primary-600 hover:text-primary-700 font-semibold text-sm hover:underline">
            ← الرجوع
          </button>
        </div>
      </div>
    </div>
  );
}
